import React, {useEffect} from "react";
import {observer} from 'mobx-react';
import {Button} from "@mui/material";
import {useStores} from "../../../Hooks";


export const EndNode = observer(({isPreview}) => {
    const {procedureStore, generalStore} = useStores();


    useEffect(() => {
        procedureStore.sidebar = false;
        procedureStore.previewSidebar = false;
        // eslint-disable-next-line
    }, [procedureStore.sidebar, procedureStore.previewSidebar])

    useEffect(() => {
        if (procedureStore.currentSession.Paused) {
            procedureStore.currentSession.Paused = false
        }
        // eslint-disable-next-line
    }, [procedureStore.currentSession.Paused])

    const previewMsg = generalStore.translate('willDisplayInSession')

    return (
        <div className="end-node-container">
            <div className="end-node-header">
                {generalStore.translate('sessionSummary')}
            </div>
            <div className="end-node-content">
                <div className="session-data">
                    <span>{generalStore.translate('duration')}: </span>
                    <span>{isPreview && !procedureStore.sessionViewerOpen ? previewMsg : procedureStore.getSessionDuration(procedureStore.currentSession)}</span>
                </div>
                <div className="session-data">
                    <span>{generalStore.translate('stepsViewed')}: </span>
                    <span>{isPreview && !procedureStore.sessionViewerOpen ? previewMsg : procedureStore.currentSession.DebrifNodeEntries.length}</span>
                </div>
                <div className="session-data">
                    <span>{generalStore.translate('mediaAdded')}: </span>
                    <span>{isPreview && !procedureStore.sessionViewerOpen ? previewMsg : procedureStore.getMediaAddedToSession(procedureStore.currentSession)}</span>
                </div>
            </div>
            {procedureStore.sessionViewerOpen
                ? <div/>
                : <Button
                    variant="contained"
                    onClick={() => procedureStore.startNewSession(isPreview)}
                    className="start-over-btn"
                >
                    {generalStore.translate('restartProcedure')}
                </Button>
            }
        </div>
    )
});
